import _styled from '@emotion/styled/base';
import { TOASTER_DURATIONS } from './constants.js';
import { Spacing } from '../primitives/spacing.js';
import { mediaQuery } from '../primitives/media-queries.js';
import { motion, border } from '@hubble/tokens/web';

const ToasterContainer = _styled("div", {
  target: "e149ywve2"
})("display:flex;flex-direction:column;z-index:10000;position:fixed;bottom:", Spacing.scale[2], ";left:", Spacing.scale[2], ";@media ", mediaQuery.mobileXsDown, "{right:", Spacing.scale[2], ";}");
const CONTAINER_TRANSITION_STYLES = {
  entering: 'max-height: 0;',
  entered: `max-height: ${Spacing.scale[19]};`
};
const ToastContainer = _styled("div", {
  target: "e149ywve1"
})("transition:max-height ", TOASTER_DURATIONS.transition * 2, "ms ", motion.timing.easeOut, ";", ({
  transitionStatus
}) => CONTAINER_TRANSITION_STYLES[transitionStatus], ";");
const CONTENT_TRANSITION_STYLES = {
  entering: 'opacity: 0;',
  entered: 'opacity: 1;',
  exiting: 'opacity: 0; transform: translateY(-100%);'
};
const ToastContent = _styled("div", {
  target: "e149ywve0"
})("display:flex;align-items:center;justify-content:space-between;width:427px;max-width:100%;margin-top:", Spacing.scale[1.5], ";padding:", Spacing.scale[2], ";border-radius:", border.radius.md, ";background-color:", ({
  theme
}) => theme.colorScheme.background.primary, ";transition-property:transform,opacity;transition-timing-function:", motion.timing.easeOut, ";transition-duration:", TOASTER_DURATIONS.transition, "ms;", ({
  transitionStatus
}) => CONTENT_TRANSITION_STYLES[transitionStatus], ";");

export { ToastContainer, ToastContent, ToasterContainer };
